import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DiffPart } from '../../../../../shared/models/internal/diffs/diff-part';
import { NgClass } from '@angular/common';
import { PartType } from '../../../../../shared/enums/part-type';

@Component({
  selector: 'app-diff-line',
  imports: [NgClass],
  templateUrl: './diff-line.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './diff-line.scss',
})
export class DiffLine {
  @Input() public line?: DiffPart[];

  protected readonly partType = PartType;
}
